import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import TextArea from '../common/TextArea';
import { selectBannerSlide, setSelectedBanner, toggleBannerSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createBanner, updateBanner } from '../../store/slices/api/inner/bannerSlice';
import Select from '../common/Select';

const BannerForm = ({ defaultData, fetchData, panelTitle}) => {

    const BannerIsOpen = useSelector(selectBannerSlide);
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);

    const statusOptions = [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ]

    const defaultValues = {
        title: defaultData?.title ?? "",
        description: defaultData?.description ?? "",
        status: defaultData?.status ?? "active",
    }

    const afterAPICall = (response) => {
        fetchData();
        dispatch(toggleBannerSlide());
        dispatch(setSelectedBanner(null));
    }

    const beforeAPICall = (data) => {
        const formData = new FormData();
        formData.append('title', data?.title);
        formData.append('description', data?.description);
        formData.append('status', data?.status ?? "");
        if (file) {
            formData.append('bannerImage', file);
        }
        return {
            success: true,
            refactoredData: {
                formData,
                query: {
                    bannerId: defaultData?.banner_id ?? "",
                },
            },
        };
    }

    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateBanner : createBanner,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('title', defaultData.title ?? "");
            setValue('description', defaultData.description ?? "");
            setValue('status', defaultData.status ?? "");
        } else {
            setValue('title', "");
            setValue('description', "");
            setValue('status', "");
        }
    }, [defaultData, setValue]);

    return (
        <SlideOver isOpen={BannerIsOpen} toggleOpen={toggleBannerSlide} panelName={defaultData ? "Update Banner" : "Add Banner"}>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="title"
                    rules={{ required: "this field is required" }}
                    label="Title"
                />
                <Input
                    control={control}
                    type='file'
                    name="bannerImage"
                    onChange={(event) => { setFile(event.target.files ? event.target.files[0] : null) }}
                    label="Banner Image"
                />
                <TextArea
                    control={control}
                    name="description"
                    rules={{ required: "this field is required" }}
                    label="Description"
                />
                <Select
                    control={control}
                    name="status"
                    rules={{ required: "this field is required" }}
                    options={statusOptions}
                />
                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default BannerForm;
